import green from 'material-ui/colors/green'

export default theme => ({

  card: {
    display: 'inline-block',
    width: theme.spacing.unit * 55,
    marginTop: '10vh',
    backgroundColor: green[100],
    color: green[800]
  }

})



// WEBPACK FOOTER //
// ./src/styles/pages/auth/confirm/success.js